import { SRPSEODataStrategies } from './SRPSEODataStrategies';
import { SRP_TYPES } from './SRPTypes.definitions';

export function getSEOForSRPType(type, ...args) {
  const strategy = SRPSEODataStrategies[type];
  if (!strategy) {
    console.error(`[SRP] Unknown page type "${type}".`);
    return SRPSEODataStrategies[SRP_TYPES.DEFAULT](...args);
  }
  return strategy(...args);
}
